module.exports = __webpack_public_path__ + "static/media/loading.ac5bab44.svg";